import React, { useEffect } from "react";
//import PropTypes from "prop-types";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemText,
  ListGroupItemHeading,
  Badge
} from "reactstrap";
// import firebase from "./firebase";
import firebase from "../firebase";
import useFirestoreCollQuery from "../hooks/use-fs-coll-query";
import { Bar } from "./loader";

import "./course-list.css";

const CourseList = ({
  getSelectedCourse,
  getSelectedLang,
  courseName,
  getCourses
}) => {
  const db = firebase.firestore();
  const coursesRef = db.collection("courses");

  const { loading, data } = useFirestoreCollQuery(coursesRef);

  //console.log("CourseList called -> ", courseName);

  useEffect(() => {
    data && getCourses(data.docs);
  }, [data]);

  const selectCourse = course => {
    //console.log("Selected course: ", JSON.stringify(course));
    getSelectedCourse(course);
    getSelectedLang(course.language);
  };

  const courseListView =
    data &&
    data.docs.map(doc => (
      <ListGroupItem
        key={doc.id}
        // tag="a"
        href="#"
        action
        onClick={() => selectCourse(doc.data())}
        style={{
          lineHeight: "0.5",
          paddingTop: "1px",
          paddingBottom: "1px",
          fontSize: "0.9rem",
          margin: "0"
        }}
      >
        <ListGroupItemHeading>
          {doc.data().course}{" "}
          <Badge pill style={{ fontSize: "11px", fontWeight: "normal" }}>
            {doc.data().level}
          </Badge>
        </ListGroupItemHeading>

        <ListGroupItemText
          className="text-wrap"
          style={{
            fontSize: "14px"
          }}
        >
          {doc.data().courseName}
        </ListGroupItemText>
      </ListGroupItem>
    ));

  return (
    <div>
      <Bar loading={loading} />
      <ListGroup
        flush
        style={{
          listStyle: "none",
          margin: 0,
          paddingLeft: "7px",
          paddingRight: "7px",
          borderBottom: "1px solid #dfe2e5"
        }}
      >
        {courseListView}
      </ListGroup>
    </div>
  );
};

export default CourseList;
